import React from 'react';
import { Trees, Sprout, Leaf, Layers, Snowflake, Cylinder, Ruler, Trash2, Blocks, Building2, Flower2, Wind } from 'lucide-react';
const services = [{
  title: 'Landscape Installation & Design',
  description: 'Transform your outdoor space with professional landscape design, creating beautiful, functional gardens tailored to your style.',
  icon: Trees
}, {
  title: 'Spring Clean Up',
  description: 'Refresh your property after winter — removing debris, edging beds, and preparing lawns for healthy spring growth.',
  icon: Sprout
}, {
  title: 'Lawn Care & Maintenance',
  description: 'Reliable, high-quality lawn care that keeps your lawn healthy, clean, and looking its absolute best year-round.',
  icon: Leaf
}, {
  title: 'Sod & Seeding',
  description: 'Quickly transform your lawn with lush, vibrant grass. We expertly prepare and install quality sod or seed for healthy growth.',
  icon: Layers
}, {
  title: 'Commercial & Residential Snowplowing',
  description: 'Dependable snow removal and ice management keeping driveways, walkways, and parking lots safe and clear all winter.',
  icon: Snowflake
}, {
  title: 'Lawn Rolling',
  description: 'Smooth uneven terrain, compress soil, and improve grass root contact for a lush, level landscape you will love.',
  icon: Cylinder
}, {
  title: 'Grading & Resloping',
  description: 'Ensure optimal drainage to prevent water damage and erosion while enhancing your landscape, tailored to your needs.',
  icon: Ruler
}, {
  title: 'Dumpster Rentals',
  description: 'Streamline your projects with convenient dumpster rentals — perfect for debris removal and hassle-free yard clean-ups.',
  icon: Trash2
}, {
  title: 'Hardscaping',
  description: 'Expertly crafted patios, pathways, and retaining walls that blend function and beauty into an elegant living space.',
  icon: Blocks
}, {
  title: 'Commercial Landscape',
  description: 'Trusted by businesses, property managers, and HOAs to keep commercial properties clean, professional, and well-maintained.',
  icon: Building2
}, {
  title: 'Shrub & Plant Installation',
  description: 'The right plants in the right places — refreshing existing beds or building brand-new landscapes to boost curb appeal.',
  icon: Flower2
}, {
  title: 'Fall Clean Up',
  description: 'Remove leaves, debris, and dead plants to keep your property neat, healthy, and winter-ready before the cold arrives.',
  icon: Wind
}];
export function Services() {
  return <section id="services" className="bg-muted/50 py-16 md:py-24" data-id="element-178">
      <div className="container max-w-screen-2xl" data-id="element-179">
        <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-180">
          <p className="text-sm font-semibold uppercase tracking-widest text-primary mb-3" data-id="element-181">
            What We Do
          </p>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4" data-id="element-182">
            Complete Care You Can Count On
          </h2>
          <p className="text-lg text-muted-foreground" data-id="element-183">
            From landscape design to dependable winter snow removal, our team
            delivers professional, year-round property care you can trust.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-184">
          {services.map((service, index) => <div key={index} className="group rounded-2xl bg-background p-6 shadow-sm border border-border/50 transition-all hover:shadow-md hover:border-primary/40 flex flex-col" data-id="element-185">
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground" data-id="element-186">
                <service.icon className="h-6 w-6" data-id="element-187" />
              </div>
              <h3 className="text-lg font-bold mb-2" data-id="element-188">{service.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed" data-id="element-189">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}